import { render, staticRenderFns } from "./dian.vue?vue&type=template&id=1be783f6&scoped=true&"
import script from "./dian.vue?vue&type=script&lang=js&"
export * from "./dian.vue?vue&type=script&lang=js&"
import style0 from "./dian.vue?vue&type=style&index=0&id=1be783f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be783f6",
  null
  
)

export default component.exports